import React from 'react';
import { Container, Row, Col, Card, CardBody, ListGroup, ListGroupItem, Badge } from 'reactstrap';
import { 
  FaUser, 
  FaTags, 
  FaShieldAlt, 
  FaInfoCircle, 
  FaFileAlt, 
  FaSignOutAlt, 
  FaSignInAlt,
  FaList,
  FaEnvelope
} from 'react-icons/fa';
import './styles.css';
import MainLayout from '../../layouts/MainLayout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context';
import { API_URL } from '../../utils/constants';
import { BsBuildings } from 'react-icons/bs';
import { MdOutlineTranslate } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const cardStyle = {
  cursor: 'pointer',
  position: 'relative'
};

const iconWrapperStyle = {
  width: '60px',
  height: '60px',
  borderRadius: '12px',
  background: 'linear-gradient(135deg, #e3f2fd 0%, #e8f5e9 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.3s ease'
};

function MenuPage() {
  const { t } = useTranslation();
  const { isLoggedIn, handleLogout, user } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    const response = await fetch(API_URL+'/logout', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    const data = await response.json();      
    if (data.success) {
      if(data.success) {
        handleLogout();
        navigate("/");
      }
    } else {
      console.log("Error:", data);
    }
  }

  const changeLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en');
    localStorage.setItem('i18nextLng', i18n.language === 'en' ? 'ar' : 'en');
  }

  return (
    <MainLayout>
      <Container className="py-4">
        <Row className="justify-content-center">
          <Col xs="12" sm="8" md="6" lg="4">

            {isLoggedIn ?
              <Card className="mb-3">
                <ListGroup flush>
                  <ListGroupItem 
                    action 
                    className="d-flex align-items-center py-3"
                    onClick={() => navigate('/profile')}
                  >
                    <FaUser className="me-3 text-primary" />
                    <span>{t('menu.account')}</span>
                    <span className="ms-auto">›</span>
                  </ListGroupItem>

                  {Number(user?.is_office) === 1 &&
                    <ListGroupItem 
                      action 
                      className="d-flex align-items-center py-3"
                      onClick={() => navigate('/office/'+user.id)}
                    >
                      <BsBuildings className="me-3 text-primary" />
                      <span>{t('menu.office')}</span>
                      <span className="ms-auto">›</span>
                    </ListGroupItem>
                  }
                  
                  <ListGroupItem 
                    action 
                    className="d-flex align-items-center py-3"
                    onClick={() => navigate('/my_properties')}
                  >
                    <FaTags className="me-3 text-success" />
                    <span>{t('menu.my_properties')}</span>
                    <span className="ms-auto">›</span>
                  </ListGroupItem>

                  <ListGroupItem 
                    action 
                    className="d-flex align-items-center py-3"
                    onClick={() => navigate('/plans')}
                  >
                    <FaList className="me-3 text-success" />
                    <span>{t('menu.plans')}</span>
                    <span className="ms-auto">›</span>
                  </ListGroupItem>
                </ListGroup>
              </Card>
            :
              <Card className="mb-3">
                <ListGroup flush>
                  <ListGroupItem 
                    action 
                    className="d-flex align-items-center py-3"
                    onClick={() => navigate('/login')}
                  >
                    <FaSignInAlt className="me-3 text-primary" />
                    <span>{t('menu.login_register')}</span>
                    <span className="ms-auto">›</span>
                  </ListGroupItem>
                </ListGroup>
              </Card>
            }

            <Card className='mb-3'>
              <ListGroup flush>
                <ListGroupItem
                  action
                  className="d-flex align-items-center py-3"
                  onClick={changeLanguage}
                >
                  <MdOutlineTranslate className="me-3 text-primary" />
                  { i18n.language === 'en' ? 'عربي' : 'English' }
                  <span className="ms-auto">›</span>
                </ListGroupItem>
              </ListGroup>
            </Card>

            {/* Links */}
            <Card className="mb-3">
              <ListGroup flush>
                <ListGroupItem 
                  action 
                  className="d-flex align-items-center py-3"
                  onClick={() => navigate('/contact')}
                >
                  <FaEnvelope className="me-3 text-info" />
                  <span>{t('menu.contact')}</span>
                  <span className="ms-auto">›</span>
                </ListGroupItem>

                <ListGroupItem 
                  action 
                  className="d-flex align-items-center py-3"
                  onClick={() => navigate('/privacy')}
                >
                  <FaShieldAlt className="me-3 text-info" />
                  <span>{t('menu.privacy')}</span>
                  <span className="ms-auto">›</span>
                </ListGroupItem>
                
                <ListGroupItem 
                  action 
                  className="d-flex align-items-center py-3"
                  onClick={() => navigate('/about')}
                >
                  <FaInfoCircle className="me-3 text-info" />
                  <span>{t('menu.about')}</span>
                  <span className="ms-auto">›</span>
                </ListGroupItem>
                
                <ListGroupItem 
                  action 
                  className="d-flex align-items-center py-3"
                  onClick={() => navigate('/terms')}
                >
                  <FaFileAlt className="me-3 text-info" />
                  <span>{t('menu.terms')}</span>
                  <span className="ms-auto">›</span>
                </ListGroupItem>
              </ListGroup>
            </Card>

            {isLoggedIn &&
              <Card>
                <ListGroup flush>
                  <ListGroupItem 
                    action 
                    className="d-flex align-items-center py-3 text-danger"
                    onClick={logout}
                  >
                    <FaSignOutAlt className="me-3" />
                    <span>{t('menu.logout')}</span>
                  </ListGroupItem>
                </ListGroup>
              </Card>
            }

            <div className="text-center mt-4">
              <small className="text-muted">{t('menu.version')} 1.3.0</small>
            </div>
          </Col>
        </Row>
      </Container>
    </MainLayout>
  );
}

export default MenuPage;